import { k } from "../kaplay";

export function attack({ damage, attackFunc }){
  return {
    id: "attack",
    damage: damage,
    attacked(){
      if (attackFunc) attackFunc();
    }
  }
}